import { API, AUTH } from "../store"
import { openSnackBar } from "./snack-bar"
import serialize from "../store/serialize"
import handleCatch from "../lib/catch"
import { updateCrewMember } from "./crew"
import { updateLoggedInUser } from "./authentication"
import { isEmpty } from "lodash"

// export const lengthCrew = data => ({
//   type: "CREW::LENGTH_PUSH_NEW",
//   data,
// })

export const updatingUser = (updatingUser = true) => ({
  type: "USER::UPDATING_USER",
  updatingUser,
})

export const _updateEditUser = (updates = {}) => ({
  type: "USER::UPDATE",
  updates,
})

export const _setEditUser = (data = {}) => ({
  type: "USER::SET",
  data,
})

export const setUserDefaultFilters = (data = null) => ({
  type: "USER::SET::USER_DEFAULT_FILTERS",
  data: data,
})

export const setCreatedClient = createdClient => ({
  type: "USER::SET_CREATED_CLIENT",
  createdClient,
})

export const setCreatedProducer = createdProducer => ({
  type: "USER::SET_CREATED_PRODUCER",
  createdProducer,
})

export const toggleProfileDialog = (profileDialogOpen = false, editUser) => ({
  type: "USER::TOGGLE_PROFILE_DIALOG",
  profileDialogOpen,
  editUser,
})

export const toggleCreateUserDialog = (
  createUserDialogOpen = false,
  editUser
) => ({
  type: "USER::TOGGLE_CREATE_USER_DIALOG",
  createUserDialogOpen,
  editUser,
})

export const toggleCreateClientDialog = (
  createClientDialogOpen = false,
  editUser
) => ({
  type: "USER::TOGGLE_CREATE_CLIENT_DIALOG",
  createClientDialogOpen,
  editUser,
})
export const toggleCreateProducerDialog = (
  createProducerDialogOpen = false,
  editUser
) => ({
  type: "USER::TOGGLE_CREATE_PRODUCER_DIALOG",
  createProducerDialogOpen,
  editUser,
})

export const toggleCreateCalendarDialog = (
  createCalendarDialogOpen = false,
  createCalendarDialogProps
) => ({
  type: "USER::TOGGLE_CREATE_CALENDAR_DIALOG",
  createCalendarDialogOpen,
  createCalendarDialogProps,
})

export const setUserRating = (userId, rating = {}, avgRating) => ({
  type: "USER::RATING::SET",
  userId,
  rating,
  avgRating,
})

export const setBookModal = payload => ({
  type: "USER::SET::BOOK_MODAL",
  payload,
})

export const setCrewModal = payload => ({
  type: "USER::SET::CREW_MODAL",
  payload,
})

export const _updateUser = updates => {
  return dispatch => {
    dispatch(_updateEditUser(updates))
    dispatch(updateCrewMember(updates))
    dispatch(updateLoggedInUser(updates))
  }
}

export const getUserByReel = reel_scout_id => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.get(`/reel/${reel_scout_id}/book`)

          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }
            return response
          })
          .then(response => response.body)
          .then(data => {
            dispatch(setBookModal(data.response_book))
            dispatch(setCrewModal(data.outputResult))
            resolve()
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

////////////////// Get Uer From Search 3 Character /////////////////////
export const userSearch = inputValue => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.get(`/users/usersGetByName/${inputValue}`).then(response => {
          if (!response.ok) {
            throw Error(response.statusText)
          }

          return response
        })
      }
      call()
    })
    return deferred
  }
}

//////////////////////

export const getUser = (id, isAuth) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = isAuth => {
        let agent = API
        if (isAuth) {
          agent = AUTH
        }
        agent
          .get(`/users/${id}`)
          .then(response => response.body)
          .then(response => {
            if (response.message === "User found") {
              serialize("user", response.data).then(response => {
                resolve(response)
              })
            } else {
              reject("not found")
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(() => call(isAuth))
              .catch(reject)
          })
      }
      call(isAuth)
    })
    return deferred
  }
}

export const startCalendar = id => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.get(`/calendar/start/${id}`)
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(() => call())
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const activateCalendar = id => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.get(`/calendar/activate/${id}`)
          .then(response => {
            dispatch(startCalendar(id))
            resolve(response)
            // if (response.body.message === "Calendar created") {
            //   resolve(response)
            // } else {
            //   reject("Unable to create calendar")
            // }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(() => call())
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const shareCalendar = id => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.get(`/calendar/share/${id}`)
          .then(response => response.body)
          .then(response => {
            if (response.message === "Calendar shared") {
              resolve(response)
            } else {
              reject("Unable to share calendar")
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(() => call())
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const getCalendar = id => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.get(`/calendar/${id}`)
          .then(response => response.body)
          .then(response => resolve(isEmpty(response)))
          .catch(err => {
            handleCatch(err, dispatch)
              .then(() => call())
              .catch(() => reject("cannot get calendar"))
          })
      }
      call()
    })
    return deferred
  }
}

export const getUserByPhone = phone => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.get(`/users/${phone}/exists`)
          .then(response => response.body)
          .then(response => {
            if (response.message === "User exists") {
              dispatch(getUser(response.data.id, true))
                .then(getUserResponse => {
                  resolve(getUserResponse)
                })
                .catch(reject)
            } else {
              reject("not found")
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(() => call())
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const createUser = data => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(`/users`)
          .send(data)
          .then(response => response.body)
          .then(response => {
            if (response.message === "User created") {
              dispatch(getUser(response.id)).then(
                user => {
                  resolve(user)
                },
                function(err) {
                  reject(err)
                }
              )
            } else {
              if (response.message === "phone number does not exist") {
                reject(response.message)
              } else {
                reject(response.error)
              }
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const updateUser = (userId, data) => {
  return dispatch => {
    dispatch(updatingUser())
    return API.post(`/users/${userId}`)
      .send(data)
      .then(response => {
        if (!response.ok) {
          throw Error(response.statusText)
        }

        dispatch(updatingUser(false))

        return response
      })
      .then(response => response.body)
      .then(response => {
        if (response.msg === "user updated") {
          dispatch(
            openSnackBar({
              message: "Profile Updated",
            })
          )
        }
      })
  }
}

export const createStripeAccount = data => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post("/create-stripe-user")
          .send(data)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const createAdwaStripeAccount = data => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post("/create-stripe-user-adwa")
          .send(data)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const completeStripeAccount = stripeId => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.put(`/complete-user-profile/${stripeId}`)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const refreshStripeUrl = stripeAccount => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.get(`/refresh-stripe-url/${stripeAccount}`)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const disconnectStripeAccount = stripeAccount => {
  let url = `/delete-connected-account/${stripeAccount}`
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.delete(url)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }
            return response
          })
          .then(response => response.body)
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const createGalleryImage = (data, userId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(`/generic/gallery${userId ? "/user/" + userId : ""}`)
          .send(data)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }
            return response
          })
          .then(response => response.body)
          .then(response => {
            if (response.message === "gallery created") {
              resolve(response)
            } else {
              reject()
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const updateGalleryImage = (data, galleryId, userId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(
          `/generic/gallery/${galleryId}${userId ? "/user/" + userId : ""}`
        )
          .send(data)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            if (response.message === "gallery updated") {
              resolve(response)
            } else {
              reject()
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const removeGalleryImage = (galleryId, userId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.delete(
          `/generic/gallery/${galleryId}${userId ? "/user/" + userId : ""}`
        )
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            if (response.message === "gallery deleted") {
              resolve(response)
            } else {
              reject()
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const saveDefaultFilters = (data, userId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(`/users/${userId}/filters`)
          .send(data)
          .then(response => response.body)
          .then(response => {
            if (response.message === "default filters updated") {
              dispatch(getDefaultFilters(userId)).then(() => {
                resolve()
              })
            } else {
              reject()
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const getDefaultFilters = userId => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.get(`/users/${userId}/filters`)
          .then(response => response.body)
          .then(response => {
            if (
              response &&
              response.defaultFilters &&
              response.defaultFilters.length > 0
            ) {
              dispatch(setUserDefaultFilters(response.defaultFilters[0]))
            } else {
              dispatch(setUserDefaultFilters())
            }
            resolve()
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(() => call())
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const removeDefaultFilters = userId => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.delete(`/users/${userId}/filters`)
          .then(response => response.body)
          .then(response => {
            if (response && response.message === "filters removed") {
              dispatch(setUserDefaultFilters())
              resolve()
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(() => call())
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const getUserBookingHistory = data => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(`/booking/history`)
          .send(data)
          .then(response => response.body)
          .then(response => resolve(response))
          .catch(err => {
            handleCatch(err, dispatch)
              .then(() => call())
              .catch(() => reject("cannot get user Booking history"))
          })
      }
      call()
    })
    return deferred
  }
}

export const toggleUserGTT = (userId, data) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.put(`/create-gtt-member/${userId}`)
          .send(data)
          .then(response => response.body)
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}
